import React from 'react';
import styled from 'styled-components';

const SuccessContainer = styled.div`
  text-align: center;
  padding: 48px 16px;
`;

const SuccessIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const SuccessTitle = styled.h2`
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--tg-theme-text-color, #000000);
`;

const SuccessText = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  color: var(--tg-theme-hint-color, #999999);
  line-height: 1.5;
`;

const CloseNote = styled.p`
  margin: 0;
  font-size: 14px;
  color: var(--tg-theme-hint-color, #999999);
  font-style: italic;
`;

function SuccessMessage() {
  return (
    <SuccessContainer>
      <SuccessIcon>🎉</SuccessIcon>
      <SuccessTitle>Опрос завершен!</SuccessTitle>
      <SuccessText>
        Спасибо за участие в опросе.
        <br />
        Ваши ответы успешно сохранены.
      </SuccessText>
      <CloseNote>
        Приложение автоматически закроется через несколько секунд...
      </CloseNote>
    </SuccessContainer>
  );
}

export default SuccessMessage; 